__turbopack_context__.v({
  "calculator": "PricingCalculator-module__hzzo_q__calculator",
  "controls": "PricingCalculator-module__hzzo_q__controls",
  "controlsBody": "PricingCalculator-module__hzzo_q__controlsBody",
  "cta": "PricingCalculator-module__hzzo_q__cta",
  "includedList": "PricingCalculator-module__hzzo_q__includedList",
  "includedTitle": "PricingCalculator-module__hzzo_q__includedTitle",
  "metaCard": "PricingCalculator-module__hzzo_q__metaCard",
  "metaFigure": "PricingCalculator-module__hzzo_q__metaFigure",
  "metaFootnote": "PricingCalculator-module__hzzo_q__metaFootnote",
  "metaHeader": "PricingCalculator-module__hzzo_q__metaHeader",
  "metaLabel": "PricingCalculator-module__hzzo_q__metaLabel",
  "metaLine": "PricingCalculator-module__hzzo_q__metaLine",
  "metaRow": "PricingCalculator-module__hzzo_q__metaRow",
  "metaValue": "PricingCalculator-module__hzzo_q__metaValue",
  "optionAmount": "PricingCalculator-module__hzzo_q__optionAmount",
  "optionContent": "PricingCalculator-module__hzzo_q__optionContent",
  "optionGroup": "PricingCalculator-module__hzzo_q__optionGroup",
  "optionUnit": "PricingCalculator-module__hzzo_q__optionUnit",
  "partnershipBadge": "PricingCalculator-module__hzzo_q__partnershipBadge",
  "perfectFor": "PricingCalculator-module__hzzo_q__perfectFor",
  "perfectForList": "PricingCalculator-module__hzzo_q__perfectForList",
  "perfectForTitle": "PricingCalculator-module__hzzo_q__perfectForTitle",
  "priceCard": "PricingCalculator-module__hzzo_q__priceCard",
  "priceCardDiscounted": "PricingCalculator-module__hzzo_q__priceCardDiscounted",
  "priceHint": "PricingCalculator-module__hzzo_q__priceHint",
  "priceLabel": "PricingCalculator-module__hzzo_q__priceLabel",
  "priceValue": "PricingCalculator-module__hzzo_q__priceValue",
  "summary": "PricingCalculator-module__hzzo_q__summary",
  "summaryFooter": "PricingCalculator-module__hzzo_q__summaryFooter",
  "title": "PricingCalculator-module__hzzo_q__title",
  "totalCard": "PricingCalculator-module__hzzo_q__totalCard",
  "totalLabel": "PricingCalculator-module__hzzo_q__totalLabel",
  "totalNote": "PricingCalculator-module__hzzo_q__totalNote",
  "totalValue": "PricingCalculator-module__hzzo_q__totalValue",
});
